export const KEYS = ['Enter', ' ', 'Spacebar'];
